export default "__VITE_ASSET__558c31a0__"